import React from 'react';
import { REPORT_GRID_STYLE, findMaxItems, calculateRowHeight } from 'components/Pages/Reports/helpers.js';
import { AutoGrid } from '@bit/knotchinc.web-react-components.grid';
import { formatterWithWord, numberWithCommas } from 'helpers/Utils.js';
import Tag from 'components/Global/Tag/Tag.jsx';
import { ListTitle, Section } from 'components/Pages/Reports/styled.js';
import EntityListCard from 'components/Pages/Reports/EntityListCard.jsx';
import ReportLeaderboard from 'components/Pages/Reports/ReportLeaderboard/ReportLeaderboard.jsx';
import EntityOverview from './EntityOverview.jsx';
import PageLayoutGenerator from './PageLayoutGenerator.jsx';

const KeywordsReportTab = ({
  report: {
    keywords: { entities_by_common_keywords, top_keywords_by_entity, top_keywords_by_num_contents },
    request: { report_type: reportType },
  },
}) => {
  const maxEntities = findMaxItems(entities_by_common_keywords, 'resources');
  const rowHeight = calculateRowHeight(maxEntities, 'keyword');

  const CommonKeywordsCols = entities_by_common_keywords.length
    ? AutoGrid({
      rowHeight,
      cols: entities_by_common_keywords.map(({ keyword, resources }) => (
        <EntityListCard
          title={<Tag data={keyword} />}
          resources={resources}
          formatter={formatterWithWord('Content Pieces', numberWithCommas)}
          type="keywords"
        />
      )),
      gridStyle: REPORT_GRID_STYLE,
    })
    /* If no data is available, error state */
    : AutoGrid({
      rowHeight: 615,
      cols: [
        <EntityListCard title={<Tag data="Keyword" />} type="keywords" resources={[]} />,
        <EntityListCard title={<Tag data="Keyword" />} type="keywords" resources={[]} />,
        <EntityListCard title={<Tag data="Keyword" />} type="keywords" resources={[]} />,
        <EntityListCard title={<Tag data="Keyword" />} type="keywords" resources={[]} />,
        <EntityListCard title={<Tag data="Keyword" />} type="keywords" resources={[]} />,
      ],
      gridStyle: REPORT_GRID_STYLE,
    });

  return (
    <React.Fragment>
      <PageLayoutGenerator>
        <Section>
          <ListTitle>KEYWORDS OVERVIEW</ListTitle>
          <ReportLeaderboard type="keyword" data={top_keywords_by_num_contents} reportType={reportType} />
        </Section>
        <Section>
          <ListTitle>{`TOP 5 KEYWORDS ACROSS ${reportType}S`}</ListTitle>
          <CommonKeywordsCols />
        </Section>
      </PageLayoutGenerator>
      <EntityOverview title={`MOST USED KEYWORDS BY ${reportType}`} data={top_keywords_by_entity} type="keywords" />
    </React.Fragment>
  );
};

export default KeywordsReportTab;
